module.exports = __webpack_public_path__ + "img/Mb_news.384e421f.jpg";